//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';
import { CalendarEventUpdateStudentChangeMode, PricePerParticipantTypeEnum } from './Enums';

export class CalendarEventUpdateItem extends ItemBase {
    AllDay: boolean = false;
    StudentChangeMode: CalendarEventUpdateStudentChangeMode = CalendarEventUpdateStudentChangeMode.Absolute;
    StudentIDs: string[] = [];
    Description: string | null = null;
    DisplayDescriptionOnCalendar: boolean = false;
    Duration: number = 0;
    EventLocationID: string | null = null;
    EventCategoryID: string | null = null;
    EventTaxIDs: string[] = [];
    IsPublic: boolean = false;
    MakeupRequired: boolean = false;
    MaximumNumberOfParticipants: number = 0;
    OriginalTeacherID: string | null = null;
    PricePerParticipant: number | null = null;
    PricePerParticipantType: PricePerParticipantTypeEnum = PricePerParticipantTypeEnum.ParticipantDefaultPrice;
    PrivateDescription: string | null = null;
    RepeatDetails: RepeatDetailsItem | null = null;
    StartDate: string = "1970-01-01T00:00:00";
    TeacherID: string | null = null;
    UpdateFutureEvents: boolean = false;
    HoldTimeSlot: boolean = false;

    constructor(initializer?: Partial<CalendarEventUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "CalendarEventUpdateItem";
}
